function init() {
	// Loop through all forms on page
	for (const form of document.querySelectorAll("form")) {
		// Find recaptcha token field in form
		const recaptchaFld = form.querySelector('input[name="recaptcha-token"]');

		// If found...
		if (recaptchaFld) {
			// Get submit button on form
			const formSubmitBtn = form.querySelector('button[type="submit"]');

			// If found...
			if (formSubmitBtn) {
				// When form submit button clicked...
				formSubmitBtn.addEventListener("click", function (e) {
					// Prevent submitting form immediately
					e.preventDefault();

					let formIsValid = true;
					for (const fld of form.querySelectorAll("input, select, textarea")) {
						// if (fld.checkValidity() === false) {
						if (!fld.validity.valid) {
							fld.reportValidity();
							formIsValid = false;
						}
					}

					if (formIsValid === false) {
						return;
					}

					// Disable button when it's been clicked to prevent multiple clicks
					formSubmitBtn.setAttribute("disabled", "disabled");

					// When recaptcha script is ready...
					grecaptcha.ready(function () {
						// Run the recaptcha execute function to generate the token
						// grecaptcha.execute('{{ craft.app.config.custom.recaptchaSiteKey }}', {action: 'submit'})
						grecaptcha.execute(recaptchaSiteKey).then(function (token) {
							// Set the token as the value of the hidden recaptcha field
							recaptchaFld.value = token;

							form.submit();
						});
					});
				});
			}
		}
	}
}

export default init;
